import React from 'react';
import type {
  RaterXCoverage,
  SE,
} from '../../../../../../api/types/rater-x-preset';
import type { UpdateCoveragePayload } from '../../../../../../reducer';
import type { SEFormValues } from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecifiedEventExclusionModal';
import SpecifiedEventExclusionModal from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecifiedEventExclusionModal';
import {
  formatSEForState,
  getDefaultSEValues,
} from '../../amendatory-coverages/line-items/SpecifiedEventExclusion';

const RaterXSpecifiedEventExclusionModal = ({ data, close }: ModalProps) => {
  const onSubmit = (formValues: SEFormValues) => {
    const _exclusions = formatSEForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          exclusions: { values: _exclusions as unknown as SE[] },
        },
      },
    });
  };

  return (
    <SpecifiedEventExclusionModal
      close={close}
      data={{
        onSubmit,
        exclusions: getDefaultSEValues(
          data.coverageState.value?.props?.exclusions?.values as SE[]
        ),
      }}
    />
  );
};

export default RaterXSpecifiedEventExclusionModal;

type ModalProps = {
  data: {
    coverageState: RaterXCoverage;
    setCoverage: (payload: UpdateCoveragePayload) => void;
  };
  close: () => void;
};

export const RaterXSpecifiedEventExclusionModalConfig = {
  RaterXSpecifiedEventExclusionModal: {
    component: RaterXSpecifiedEventExclusionModal,
    config: {
      title: 'Specified Event Exclusion Endorsement (SE)',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
